import { createFileRoute } from "@tanstack/react-router"
import { FinanceOverviewPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/finance/overview"
)({
  component: () => (
    <AuthorizationGate resource={Resource.PAYMENT} action={Action.READ}>
      <FinanceOverviewPage />
    </AuthorizationGate>
  ),
})
